<template>
    <popup :opened="dataToShow > -1" @close="changeToShow(-1)">

        <!-- BEGIN message to confirm delete a role -->
        <div v-if="dataToShow == 1" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="mb-10">Confirmation de suppression</h3>

            <h6 class="text-indigo-600 mb-10">
                Êtes vous sûr de vouloir supprimer le rôle « {{roleToEdit.name}} » ? <br>
                Cette suppression sera définitive et irrévocable.
            </h6>

            <div class="w-full flex justify-center">
                <div class="mr-5">
                    <action-button 
                        class=" relative flex flex-row"
                        border-color="border-pink-600"
                        text-color="text-pink-600"
                        bg-color="bg-pink-300"
                        libelle="ANNULER"
                        @clickAction="changeToShow(-1)"
                    />
                </div>
                <div>
                    <action-button 
                        class=" relative flex flex-row"
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        libelle="SUPPRIMER"
                        type-shadow="shadow-pink"
                        @clickAction="confirmDeleteRole()"
                    />
                </div>
            </div>
        </div>
        <!-- END message to confirm delete a role -->

        <!-- BEGIN message to confirm the suppression of the role -->
        <div v-if="dataToShow == 2" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="text-indigo-600 mb-10">Le rôle « {{roleToEdit.name}} » a bien été supprimé</h3>

            <div class="w-full flex justify-center">
                <illustration name="basket" class="w-full" />
            </div>
        </div>
        <!-- END message to confirm delete a role -->

        <!-- BEGIN message KO to delete a role (referent has a default role) -->
        <div v-if="dataToShow == 3" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="text-indigo-600 mb-10">Suppression du rôle impossible</h3>
            <h6 class="text-pink-600">Le rôle {{roleToEdit.name}} ne peut pas être supprimé car il est utilisé par un référent comme rôle par défaut.</h6>
        </div>
        <!-- END message KO to delete a role (referent has the role as a default role) -->

        <!-- BEGIN message KO to delete a role (referent has the role with a beneficiary) -->
        <div v-if="dataToShow == 4" class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto">
            <h3 class="mb-10 text-indigo-600">Suppression du rôle impossible</h3>
            <h6 class="text-pink-600">Le rôle {{roleToEdit.name}} ne peut pas être supprimé car il est utilisé par un référent comme rôle sur un bénéficiaire.</h6>
        </div>
        <!-- END message KO to delete a role (referent has a default role) -->

        <!-- BEGIN error message to delete a role -->
        <div v-if="dataToShow == 100">
            <div class="m-5 lg:m-15 2xl:m-20">
                <h3 class="w-full text-indigo-600 mb-10">Erreur lors de la suppression du rôle !</h3>

                <div class="mb-10">
                    <p class="text-indigo-600 text-lg text-center">Le rôle n'a pas pu être supprimé.</p>
                </div>

                <illustration name="notAllowed" class="w-full" />
            </div>
        </div>
        <!-- END error message to delete a role -->
    </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';


export default {
  name:'DeleteRolePopup',

  props:{
    dataToShow: Number,
  },

  data() {
    return {

    };
  },

  components:{
    Popup,
    Icon,
    ActionButton,
    Illustration,
  },

  computed:{
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      roleToEdit: 'roles/roleToEdit',
    }),
  },

  methods:{
    ...mapActions({
      deleteRole: 'roles/deleteRole'
    }),

    ...mapMutations({

    }),

    changeToShow(val){
      this.$emit('showChange', val);
    },

    confirmDeleteRole(){
      this.deleteRole().then((deletedState) => {
        if(deletedState == 'ok'){ this.changeToShow(2); }
        else if(deletedState == 'referentHasRole'){ this.changeToShow(3); }
        else if(deletedState == 'beneficiaryHasRole'){ this.changeToShow(4); }
        else{ this.changeToShow(100); }
      }).catch(error => {
        this.changeToShow(100);
        console.log('ERRRR:: ', error.response.data);
      });
    }
  }
};
</script>
